import { InvoiceStatus } from "@/lib/constants/invoiceStatus";
import type { GetAllInvoiceInvoice } from "@/queries/invoices/get-all";
import type { CellContext } from "@tanstack/react-table";
import { Calendar } from "lucide-react";

export const ExecutionDateCell = ({
  row,
  format,
}: CellContext<GetAllInvoiceInvoice, unknown> & { format?: string }) => {
  const executionDate = row.original.draftPayments?.[0]?.executionDate;
  const status = row.original.invoice.status;

  if (executionDate) {
    return (
      <div className="pl-2 flex items-center gap-2">
        <Calendar className="h-4 w-4 text-muted-foreground" />
        {new Date(executionDate).toLocaleDateString("de-DE")}
      </div>
    );
  }
  if (status !== InvoiceStatus.NEW) {
    return <div className="flex justify-center items-center w-full">–</div>;
  }
  return null;
};
